import { Component, Input } from '@angular/core';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { PictureDisplay } from '@freelancer/ui/picture';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-home-page-article-item',
  template: `
    <fl-bit
      class="ArticleItem-header"
      [flMarginBottom]="Margin.XXSMALL"
      [flMarginBottomDesktop]="Margin.LARGE"
    >
      <fl-picture
        class="ArticleItem-header-image"
        [ngClass]="{
          'ArticleItem-header-image--hidden': !isIconReady
        }"
        [alt]="iconAlt"
        [src]="iconSrc"
        [fullWidth]="true"
        [alignCenter]="true"
        [lazyLoad]="true"
        [display]="PictureDisplay.BLOCK"
        [flMarginRight]="Margin.SMALL"
        (imageLoaded)="isIconReady = true"
      ></fl-picture>

      <fl-heading
        [size]="TextSize.MARKETING_SMALL"
        [sizeTablet]="TextSize.MID"
        [sizeDesktop]="TextSize.LARGE"
        [headingType]="HeadingType.H3"
      >
        {{ heading }}
      </fl-heading>
    </fl-bit>
    <fl-text
      class="ArticleItem-description"
      [size]="TextSize.XSMALL"
      [sizeDesktop]="TextSize.MARKETING_SMALL"
    >
      {{ description }}
    </fl-text>
  `,
  styleUrls: ['./article-item.component.scss'],
})
export class HomePageArticleItemComponent {
  HeadingType = HeadingType;
  Margin = Margin;
  PictureDisplay = PictureDisplay;
  TextSize = TextSize;

  isIconReady = false;

  @Input() description: string;
  @Input() heading: string;
  @Input() iconSrc: string;
  @Input() iconAlt: string;
}
